import ProfileDetail from '@containers/profile/ProfileDetail';

const ProfileDetailPage = () => {
  return <ProfileDetail />;
};

export default ProfileDetailPage;
